import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdates from './components/LatestUpdates';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState('all');
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "@id": "https://hanhancomic.com/#organization",
                "name": "汗汗漫画网",
                "url": "https://hanhancomic.com",
                "description": "汗汗漫画网主打无删减漫画下拉式免费阅读，韩国漫画完整版覆盖广泛，下拉观看操作简单，免费为您呈现各类热门韩国漫画的完整故事与细腻画面。",
                "contactPoint": {
                  "@type": "ContactPoint",
                  "email": "contact@hanhancomic.com",
                  "contactType": "customer service"
                }
              },
              {
                "@type": "WebSite",
                "@id": "https://hanhancomic.com/#website",
                "url": "https://hanhancomic.com",
                "name": "汗汗漫画网",
                "description": "汗汗漫画网主打无删减漫画下拉式免费阅读，韩国漫画完整版覆盖广泛，下拉观看操作简单，免费为您呈现各类热门韩国漫画的完整故事与细腻画面。",
                "inLanguage": "zh-CN",
                "publisher": { "@id": "https://hanhancomic.com/#organization" }
              },
              {
                "@type": "WebPage",
                "@id": "https://hanhancomic.com/#webpage",
                "url": "https://hanhancomic.com",
                "name": "首页 - 汗汗漫画网",
                "description": "汗汗漫画网首页，提供无删减韩国漫画下拉式免费阅读，最新热门漫画推荐，分类浏览，下拉观看。",
                "inLanguage": "zh-CN",
                "isPartOf": { "@id": "https://hanhancomic.com/#website" },
                "about": { "@id": "https://hanhancomic.com/#organization" }
              }
            ]
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav active={activeCategory} onSelect={setActiveCategory} />
        <HotRecommend activeCategory={activeCategory} />
        <LatestUpdates />
        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="bg-gradient-to-r from-primary-500 to-accent-500 rounded-xl p-8 md:p-12 text-center text-white">
              <h2 className="text-2xl md:text-3xl font-bold font-heading mb-3">
                汗汗漫画网 —— 无删减韩国漫画免费读
              </h2>
              <p className="text-white/80 max-w-2xl mx-auto text-sm md:text-base leading-relaxed mb-6">
                我们致力于为漫画爱好者提供<strong>最全面的韩国漫画完整版</strong>资源。所有漫画<strong>无删减、无遮挡</strong>，
                采用<strong>下拉式阅读</strong>模式，操作简单流畅，让您沉浸在漫画世界中。
                无论您是喜欢恋爱、奇幻、动作还是悬疑题材，这里都有您想要的完整故事。
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl mx-auto">
                <div className="text-center">
                  <div className="text-3xl font-bold font-heading mb-1">500+</div>
                  <div className="text-xs text-white/70">漫画资源</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold font-heading mb-1">50万+</div>
                  <div className="text-xs text-white/70">日活跃读者</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold font-heading mb-1">99.9%</div>
                  <div className="text-xs text-white/70">用户好评率</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}